import { AccessorType } from '@charting/models/accessor.type';

export class DataColumnPoint
{
    public x: any;
    public values: Map<string, number>;
    public total?: number;
}
export class DataColumn
{
    public keys: string[];
    public colors: string[];
    public colorsHover?: string[];
    public points: DataColumnPoint[] = [];
    public labels: string[] = [];
}
